import React from "react";
import { Box } from "@mui/material";
import AccountantSidebar from "./AccountantSidebar";
import AccountantAppBar from "./AccountantAppBar";

export default function AccountantLayout({ children }) {
  return (
    <Box display="flex">
      <AccountantSidebar />
      <Box flex={1}>
        <AccountantAppBar />
        <Box p={3}>{children}</Box>
      </Box>
    </Box>
  );
}
